import {State} from '../../types/state';
import {NameSpace} from '../root-reducer';
import {LoginStatus} from '../../const';
import {UserInfo} from '../../types/user-info';

export const getLoggedInFlag = (state: State): boolean => state[NameSpace.User].loginStatus === LoginStatus.LoggedIn;
export const getUserInfo = (state: State): UserInfo | null => state[NameSpace.User].userInfo;
